import SelectPaymentMethodModal from './SelectPaymentMethodModal';

export default SelectPaymentMethodModal;
